import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

export default function P34ExpertModel({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-20 right-24 w-[380px] h-[380px] rounded-full bg-primary-100/14 blur-[130px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-[400px] h-[400px] rounded-full bg-accent-100/12 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full bg-secondary-200/20 blur-[140px] pointer-events-none animate-orb-float-3" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-8 md:py-10">
        <div ref={titleRef} className="text-center mb-6 md:mb-8">
          <span className={`inline-block text-lg font-body font-semibold text-accent-600 uppercase tracking-[0.15em] mb-3 transition-all duration-700 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>专家经验锚定</span>
          <h2 className={`font-heading text-3xl md:text-5xl lg:text-[3.25rem] font-bold text-foreground-950 transition-all duration-1000 delay-100 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            专家经验如何进入<span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">专用评价模型</span>
          </h2>
        </div>

        {/* 桑基图式流程 */}
        <div className={`max-w-5xl mx-auto mb-6 md:mb-8 transition-all duration-1000 delay-200 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex flex-wrap items-center justify-center gap-x-2 md:gap-x-4 gap-y-3">
            <div className="px-6 py-5 md:px-8 md:py-6 rounded-2xl glass-liquid border-primary-200/30 text-center min-w-[200px]">
              <i className="ri-video-line text-4xl md:text-5xl text-primary-500 mb-2 block" />
              <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950">课程视频</p>
              <p className="text-lg md:text-xl text-foreground-950 mt-1">+ 专家经验</p>
            </div>

            <i className="ri-arrow-right-line text-xl md:text-2xl text-foreground-950" />

            <div className="px-6 py-5 md:px-8 md:py-6 rounded-2xl glass-liquid-gold border-accent-200/30 text-center min-w-[200px]">
              <i className="ri-price-tag-3-line text-4xl md:text-5xl text-accent-500 mb-2 block" />
              <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950">专家标注</p>
              <p className="text-lg md:text-xl text-foreground-950 mt-1">时段+指标标签</p>
            </div>

            <i className="ri-arrow-right-line text-xl md:text-2xl text-foreground-950" />

            <div className="px-6 py-5 md:px-8 md:py-6 rounded-2xl glass-liquid border-primary-200/30 text-center min-w-[200px]">
              <i className="ri-list-check-3 text-4xl md:text-5xl text-primary-500 mb-2 block" />
              <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950">评价标准</p>
              <p className="text-lg md:text-xl text-foreground-950 mt-1">统一评价表</p>
            </div>

            <i className="ri-arrow-right-line text-xl md:text-2xl text-foreground-950" />

            <div className="px-6 py-5 md:px-8 md:py-6 rounded-2xl glass-liquid-gold border-accent-200/30 text-center min-w-[200px]">
              <i className="ri-brain-line text-4xl md:text-5xl text-accent-500 mb-2 block" />
              <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950">专用模型</p>
              <p className="text-lg md:text-xl text-foreground-950 mt-1">多模态+多智能体</p>
            </div>

            <i className="ri-arrow-right-line text-xl md:text-2xl text-foreground-950" />

            <div className="px-6 py-5 md:px-8 md:py-6 rounded-2xl glass-strong border-primary-200/30 text-center min-w-[200px]">
              <i className="ri-file-chart-line text-4xl md:text-5xl text-primary-500 mb-2 block" />
              <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950">输出</p>
              <p className="text-lg md:text-xl text-foreground-950 mt-1">总分+维度分+分档+证据链</p>
            </div>
          </div>
        </div>

        {/* 底部 */}
        <div className={`max-w-3xl mx-auto text-center transition-all duration-1000 delay-500 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="inline-flex items-center gap-3 px-6 py-4 rounded-xl glass border-white/50">
            <i className="ri-information-line text-base md:text-lg text-foreground-950 flex-shrink-0" />
            <span className="text-base md:text-lg font-body text-foreground-950 leading-relaxed text-left">
              模型学习的是专家<strong className="text-primary-700">为什么作出判断</strong>，而非"这节课很好"这样的结论
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}